export const enum ArtShowingEntryType {
  STANDALONE = "artwork",
  SET = "artwork_set",
}

export interface ArtShowingEntry {
  id: string | null;
  slug: string | null;
  entry_type: string | null;
  photo_names: string[] | null;
  photo_widths: number[] | null;
  photo_heights: number[] | null;
  name: string | null;
  artist_name: string | null;
  availability: string | null;
  artwork_category?: string | null;
  /** Only populated for standalone artworks */
  listing_price?: number | null;
  /** Only populated for standalone artworks, e.g. "24 × 36 inches" */
  size_in_inches?: string | null;
  /** Normalized size for display: first two dims reordered for orientation consistency */
  display_size?: string | null;
  /** Only populated for artwork sets */
  price?: number | null;
  /** Number of pieces in a set (length of photo_names array) */
  piece_count?: number | null;
}
